import {t} from "i18next";
import {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";

interface SpamFilterQuestionProps {
	onChange: (passed: boolean) => void;
}

function SpamFilterQuestion(props: SpamFilterQuestionProps) {

	const {t} = useTranslation();
	const [spamFilterQuestion, setSpamFilterQuestion] = useState<number>(0);
	const [spamFilterFrom, setSpamFilterFrom] = useState<number>(0);
	const [spamFilterTo, setSpamFilterTo] = useState<number>(0);
	useEffect(() => {
		// Math.floor(Math.random() * 45)
		setSpamFilterFrom(Math.floor(Math.random() * 45) + 1);
		setSpamFilterTo(Math.floor(Math.random() * 10) + 1);
	}, []);
	return (<div className="flex flex-col gap-2 w-full sm:w-max">
		<label className="font-normal">
			{t("pages.contact.form.spamquestion", {
				from: spamFilterFrom,
				to: spamFilterTo
			})}
		</label>
		<input
			type={"number"}
			placeholder={
				"Tipp: " +
				(spamFilterFrom && spamFilterTo && spamFilterFrom + spamFilterTo)
			}
			className="w-full border-none shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] placeholder-leo-text-gray max-w-[180px]"
			required={true}
			onChange={(e) => {
				const answer = parseInt(e.target.value);
				setSpamFilterQuestion(answer);
				props.onChange(spamFilterFrom + spamFilterTo === answer);
			}}
		/>
	</div>);
}

export default SpamFilterQuestion;